module.exports = __webpack_public_path__ + "img/Z_Logo_EWMA_Large_Round_3.aadc42df.png";